import type { CSSProperties } from 'react';

export type LegacyStatusName = 'todo' | 'process' | 'done' | 'accept' | 'fix' | 'pause' | 'delete' | 'notrequired' | 'empty';
export type LegacyIconName = 'calendar' | 'close' | 'files' | 'filter' | 'filter-drop' | 'folder' | 'menu' | 'move' | 'search';

export function LegacyIcon({
  name,
  className = '',
  title,
  // The sprite draws every icon inside a 16x16 box, but the ink rarely fills
  // it. Pass the ink's own box to size an icon by what is actually drawn.
  viewBox = '0 0 16 16',
}: {
  name: LegacyIconName;
  className?: string;
  title?: string;
  viewBox?: string;
}) {
  return (
    <svg aria-hidden={title ? undefined : true} className={`legacy-svg-icon ${className}`.trim()} role={title ? 'img' : undefined} viewBox={viewBox}>
      {title ? <title>{title}</title> : null}
      <use href={`#icon--${name}`} />
    </svg>
  );
}

export function LegacyStatusIcon({
  name,
  large = false,
  off = false,
  className = '',
  style,
}: {
  name: LegacyStatusName;
  large?: boolean;
  off?: boolean;
  className?: string;
  style?: CSSProperties;
}) {
  const prefix = large ? '' : 'small--';
  return (
    <svg
      aria-hidden="true"
      className={`legacy-status-svg ${className}`.trim()}
      style={style}
      viewBox={large ? '0 0 49 49' : '0 0 21 21'}
    >
      <use href={`#icon--${prefix}${name}${off ? '-off' : ''}`} />
    </svg>
  );
}
